import React from 'react';
import styled from 'styled-components/macro';
import useTranslations from '../../hooks/useTranslations';
import Colors from '../../internal-components/Colors';
import isPrivilegeEqualsTo from '../../utils/isPrivilegeEqualsTo';
import Button from '@material-ui/core/Button';
import MuiMenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Menu from '@material-ui/core/Menu';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AssignmentIcon from '@material-ui/icons/Assignment';
import IdleDialog from '../../internal-components/GeneralDialog';
import SessionTimeouts from '../../utils/SessionTimeouts';
import _DontPrint from '../../internal-components/DontPrint';
import { SimpleFlexContainer, Sizes } from '../layouts/ng-layouts/Containers';

const NavBar = styled.div`
  background: #fff;
  height: ${Sizes.NAV_BAR_HEIGHT}px;
  // width: calc(100vw - 14px);
  width: 100vw;
  display: flex;
  align-items: center;
  padding: 0 30px;

  ${({ noshadow }) =>
    noshadow ? 'box-shadow: none;' : 'box-shadow: 5px 10px 12px -19px black;'}
`;

const LogoImg = styled.img`
  height: 55px;
  margin-right: 20px;
  cursor: pointer;
`;

const NavBtn = styled.span`
  padding: 0 40px;
  height: 100%;
  display: flex;
  align-items: center;
  border-bottom: 2px solid
    ${({ selected }) => (selected ? Colors.PRIMARY : '#fff')};
  cursor: pointer;
  font-weight: 500;
  font-size: 17px;
  transition: 0.25s;
  &:hover {
    // height: 80%;
    // border-bottom: 2px solid ${Colors.PRIMARY};
    color: ${Colors.PRIMARY};
  }
`;

const UserMenuWrapper = styled.span`
  margin-left: auto;
  button {
    text-transform: none;
  }
`;

const MenuItem = styled(MuiMenuItem)`
  && {
    padding-right: 2.5em;
  }
`;

const DontPrint = styled(_DontPrint)`
  position: sticky;
  top: 0;
  z-index: 100;
  flex: 0 1 auto;
`;

const NavBarView = props => {
  const t = useTranslations();

  return (
    <DontPrint>
      <NavBar noshadow={props.noshadow}>
        <LogoImg
          data-testid="navbar.homelink"
          src={props.logoSrc}
          alt="Firm logo"
          onClick={props.onLogoClick}
        />

        {!props.showNavBarBtns ? null : (
          <>
            {props.navbarBtns.map(btn =>
              props.isMenuReady ? (
                isPrivilegeEqualsTo(btn.privileges) ? (
                  <NavBtn
                    key={btn.id}
                    data-testid={'navbar.' + btn.id}
                    selected={
                      props.pageId === btn.id || props.pageId === btn.alias
                    }
                    onClick={() => props.goTo(btn.link)}
                  >
                    {t(btn.display)}
                  </NavBtn>
                ) : null
              ) : null
            )}
            <UserMenuWrapper>
              <Button
                data-testid="navbar.user"
                startIcon={<AccountCircleIcon />}
                endIcon={<ArrowDropDownIcon />}
                onClick={e => props.setUserMenuAnchorEl(e.currentTarget)}
              >{`${props.data.firstName} ${props.data.lastName}`}</Button>
            </UserMenuWrapper>
          </>
        )}
      </NavBar>
      <Menu
        id="user-menu"
        anchorEl={props.userMenuAnchorEl}
        keepMounted
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        open={Boolean(props.userMenuAnchorEl)}
        onClose={() => props.setUserMenuAnchorEl(null)}
      >
        <MenuItem
          data-testid="nav-button.home"
          onClick={() => {
            props.goTo('/welcome');
            props.setUserMenuAnchorEl(null);
          }}
        >
          <ListItemIcon>
            <AssignmentIcon fontSize="small" />
          </ListItemIcon>
          My forms
        </MenuItem>
        {!props.isSaml || props.turnedOffSSO ? (
          <MenuItem data-testid="nav-button.log-out" onClick={props.onLogout}>
            <ListItemIcon>
              <ExitToAppIcon fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        ) : null}
      </Menu>
      <IdleDialog
        open={props.isTimeoutDialogOpen}
        title="warnings.inactivity.title"
        content="warnings.inactivity"
        handleClose={() => props.setIsTimeoutDialogOpen(false)}
        handleConfirm={() => {
          props.setIsTimeoutDialogOpen(false);
          SessionTimeouts.refreshToken.call(SessionTimeouts);
        }}
      />
    </DontPrint>
  );
};

export default NavBarView;
